export default {
  redisPort: 6379,
  redisEndpoint: 'frankly-platform-qa.ahuod3.ng.0001.use1.cache.amazonaws.com',

  amsEndpoint: {
    url: 'https://managewnow.manageddev1.worldnow.com/config',
    headers: {
      'X-Parse-Application-Id': 'wPJuyJsloZ14Rx7rUIk1BLLlpmrVt7rHqD5w3iza'
    }
  },

  apiEndpoint: process.env.API_ENDPOINT || 'https://platform-qa.franklyinc.com',
  widgetApiEndpoint: process.env.WIDGET_API_ENDPOINT || 'https://api.ddev1.worldnow.com/feed/v3.0/widgets',
};



// WEBPACK FOOTER //
// ./server/config/tl.js